import { Component } from '@angular/core';
//import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'data-table-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    standalone: false
})
export class IconComponent implements ICellRendererAngularComp {
    iconClass: string;
    iconStyle: string;
    constructor(
    ) { }

    refresh(params: any): boolean {
        return true;
    }
    agInit(params: ICellRendererParams & { icons: Map<any, string>, class: string }): void {
        this.iconClass = params.icons.get(params.value);
        this.iconStyle = params.class;
    }
}
